import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import * as fromNewsletters from './store';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';
import { TextUtilityModule } from '@teamfoster/sdk/text-utility';
import { NewsletterSubscriptionFormComponent } from './components/newsletter-subscription-form/newsletter-subscription-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DynamicFormModule } from '@teamfoster/dynamic-forms';
import { IconModule } from '@teamfoster/sdk/icon';
import { CoreModule } from '../core/core.module';
import { NewsLetterPopupComponent } from './components/news-letter-popup/news-letter-popup.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [NewsletterSubscriptionFormComponent, NewsLetterPopupComponent],
  imports: [
    CommonModule,
    DictionaryNgrxModule,
    TextUtilityModule,
    ReactiveFormsModule,
    DynamicFormModule,
    IconModule,
    CoreModule,
    MatDialogModule,
    StoreModule.forFeature(fromNewsletters.featureKey, fromNewsletters.reducers, {
      metaReducers: fromNewsletters.metaReducers,
    }),
    EffectsModule.forFeature(fromNewsletters.effects),
  ],
  exports: [NewsletterSubscriptionFormComponent, NewsLetterPopupComponent],
})
export class NewslettersModule {}
